import axios from "axios";
import TraderPayoutPlanDTO from "@/models/TraderPayoutPlanDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TraderPayoutPlanCreateRequestDTO from "@/models/request/TraderPayoutPlanCreateRequestDTO";
import TraderPayoutPlanUpdateRequestDTO from "@/models/request/TraderPayoutPlanUpdateRequestDTO";
import PaginationDTO from "@/models/PaginationDTO";

export const traderPayoutPlans = {
    list: async (pagination: PaginationDTO, requestDTO: any = {}): Promise<PaginatedResponseDTO<TraderPayoutPlanDTO>> => {
        let resp = await axios({
            url: `/traffic-groups/trader-payout-plans`,
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO
            },
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            method: 'POST',
        });

        return resp.data as PaginatedResponseDTO<TraderPayoutPlanDTO>
    },
    create: async (data: TraderPayoutPlanCreateRequestDTO): Promise<TraderPayoutPlanDTO> => {
        let resp = await axios({
            url: `/traffic-groups/trader-payout-plans`,
            data,
            method: 'POST',
        });

        return resp.data as TraderPayoutPlanDTO
    },
    update: async (id: number, data: TraderPayoutPlanUpdateRequestDTO): Promise<TraderPayoutPlanDTO> => {
        let resp = await axios({
            url: `/traffic-groups/trader-payout-plans/${id}`,
            data,
            method: 'PUT',
        });

        return resp.data as TraderPayoutPlanDTO
    },
    delete: async (id: number): Promise<TraderPayoutPlanDTO> => {
        let resp = await axios({
            url: `/traffic-groups/trader-payout-plans/${id}`,
            method: 'DELETE',
        });

        return resp.data as TraderPayoutPlanDTO
    }
}
